import * as React from 'react';
import { connect } from 'react-redux';

import BaseReportingPage from '../base/BaseReportingPage';

import { fetchAudienceReachData, fetchTikTokReport, resetTikTokReport } from '../../reducers/tiktok-report';

import { mapTikTokInfluencersById } from 'selectors/reporting';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./tiktok-page.i18n.json'));

import type { Campaign, Params } from 'types';
import type { ReportingSummaryInfluencersMap, TikTokReporting } from 'modules/reporting/types';
import TikTokVideoReporting from 'modules/reporting/components/tiktok-video-reporting/TiktokVideoReporting';
import { TikTokReportingAudienceComponentData } from 'modules/reporting/types/TikTokReporting.type';

type OwnProps = {
  params: Params
};

type StateProps = {
  campaign: Campaign,
  reporting: TikTokReporting,
  influencersMapById: ReportingSummaryInfluencersMap,
  audienceData: TikTokReportingAudienceComponentData,
  isLoading: boolean,
  hasDefinedAttribution: boolean
};

type DispatchProps = {
  dispatchFetchTikTokReport: (campaignId: number) => void,
  dispatchResetTikTokReport: () => void,
  dispatchfetchAudienceReachData: (campaignId: number) => void
};

type Props = OwnProps & StateProps & DispatchProps;

const TikTokPage = ({
  campaign,
  reporting,
  influencersMapById,
  isLoading,
  params,
  hasDefinedAttribution,
  audienceData,
  dispatchFetchTikTokReport,
  dispatchResetTikTokReport,
  dispatchfetchAudienceReachData
}: Props): JSX.Element => {
  const campaignId = campaign?.id;

  React.useEffect(() => {
    if (campaignId) {
      dispatchFetchTikTokReport(campaignId);
      dispatchfetchAudienceReachData(campaignId);
    }

    return dispatchResetTikTokReport;
  }, [campaignId]);

  return (
    <BaseReportingPage
      headline={__t('tiktok_page.title')}
      params={params}
    >
      <TikTokVideoReporting
        campaign={campaign}
        influencersMapById={influencersMapById}
        isLoading={isLoading}
        hasDefinedAttribution={hasDefinedAttribution}
        tiktokVideoReporting={reporting}
        audienceData={audienceData}
      />
    </BaseReportingPage>
  );
};

const mapStateToProps = (state): StateProps => {
  const { campaignBrief, tiktokReporting, reportingMetaInfo } = state;

  return ({
    campaign: campaignBrief.brief,
    reporting: tiktokReporting.data,
    influencersMapById: mapTikTokInfluencersById(state),
    isLoading: tiktokReporting.isLoading,
    hasDefinedAttribution: reportingMetaInfo.metaInfo.hasDefinedAttribution,
    audienceData: tiktokReporting.audienceData
  });
};

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchTikTokReport: (campaignId: number) => dispatch(fetchTikTokReport(campaignId)),
  dispatchResetTikTokReport: () => dispatch(resetTikTokReport()),
  dispatchfetchAudienceReachData: (campaignId: number) => dispatch(fetchAudienceReachData(campaignId))
});

export default connect(mapStateToProps, mapDispatchToProps)(TikTokPage);
